import { useContext } from 'react';
import { SiteMetadataContext } from '../components/context/site-metadata-context';
export var useSiteMetadata = function useSiteMetadata() {
  return useContext(SiteMetadataContext);
};